module.exports = __webpack_public_path__ + "img/launchpad-texture-bsc.82c32c59.jpg";